<template>
	<div class="winner container pt-40 p-40 border-l">
		<h1 class="main-header">{{ winnerText }}</h1>

		<div class="buttons">
			<primary-button
				:disabled="waitingOnOthers"
				@click="handleNewStart"
				>{{
					!waitingOnOthers
						? "Start New Game"
						: "Waiting for others..."
				}}</primary-button
			>
			<secondary-button @click="$router.push('/login')"
				>Back to home</secondary-button
			>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import PrimaryButton from "./ui/PrimaryButton";
import SecondaryButton from "./ui/SecondaryButton";

export default {
	data() {
		return {
			waitingOnOthers: false,
		};
	},
	computed: {
		...mapGetters(["teams", "turn"]),
		winnerText() {
			return `${this.teams[this.turn % 2].players[0]} and ${
				this.teams[this.turn % 2].players[1]
			} win!`;
		},
	},
	components: {
		PrimaryButton,
		SecondaryButton,
	},
	emits: {
		"start-new-game": null,
	},
	methods: {
		...mapActions(["tryStartNewGame"]),
		handleNewStart() {
			if (!this.waitingOnOthers) {
				this.tryStartNewGame();
				this.waitingOnOthers = true;
			}
		},
	},
	created() {
		this.waitingOnOthers = false;
	},
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/main.scss";

// For whole container
.container {
	padding: 32px;
	width: 340px;
}

// Styling for buttons div
.buttons {
	margin-top: 32px;

	button {
		display: block;
		width: 100%;
		margin: 12px 0;
	}

	// For each button
	.btn {
		padding: 1em 1.5em;
	}
}
</style>
